import {createContext, useState} from "react";

export const GenderContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [genders, setGenders] = useState([]);

    // Make the context object:
    const genderContext = {
        genders,
        setGenders,
    };

    // pass the value in provider and return
    return <GenderContext.Provider value={genderContext}>{children}</GenderContext.Provider>;
}

export const {Consumer} = GenderContext;
